import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Contact} from '@rbaip/address-form';


@Component({
  selector: 'lib-item-summary-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent implements OnInit {

  @Input() editable: boolean;
  @Input() deletable: boolean;
  @Input() contact: Contact;
  @Input() contactType: string;
  @Input() placeholderText: string;
  @Input() contactTypeText: string;

  @Output() onAddContact: EventEmitter<{contact: Contact, contactType: any}> = new EventEmitter<{contact: Contact, contactType: any}>();
  @Output() onEditContact: EventEmitter<{contact: Contact, contactType: any}> = new EventEmitter<{contact: Contact, contactType: any}>();
  @Output() onDeleteContact: EventEmitter<{contact: Contact, contactType: any}> = new EventEmitter<{contact: Contact, contactType: any}>();

  constructor() {
  }

  ngOnInit() {
  }

  public addContact() {
    this.onAddContact.emit({contact: this.contact, contactType: this.contactType});
  }

  public editContact() {
    this.onEditContact.emit({contact: this.contact, contactType: this.contactType});
  }

  public deleteContact() {
    this.onDeleteContact.emit({contact: this.contact, contactType: this.contactType});
  }
}
